import {
  Title as MantineTitle,
  TitleProps as MantineTitleProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './Title.module.css';

export type TitleColor = 'primary' | 'secondary' | 'disabled' | 'error' | 'ai';

export type TitleProps = Omit<
  MantineTitleProps,
  | 'variant'
  | 'color'
  | 'styles'
  | 'classNames'
  | 'style'
  | 'c'
  | 'fw'
  | 'fz'
  | 'fs'
> & {
  color?: TitleColor;
};

export const Title = forwardRef<HTMLHeadingElement, TitleProps>(
  ({ order = 1, color, ...props }, ref) => {
    return (
      <MantineTitle
        ref={ref}
        unstyled
        className={styles.root}
        order={order}
        data-order={order}
        data-color={color}
        {...props}
      />
    );
  }
);

Title.displayName = 'Title';
